import React from 'react';
import './ShimmerLoader.css';

interface ShimmerLoaderProps {
  type?: 'card' | 'text' | 'circle' | 'stats';
  count?: number;
  height?: string;
  width?: string;
}

const ShimmerLoader: React.FC<ShimmerLoaderProps> = ({ 
  type = 'card', 
  count = 1, 
  height = '100px', 
  width = '100%' 
}) => {
  const renderShimmer = () => {
    switch (type) {
      case 'stats':
        return (
          <div className="shimmer-stats-container">
            {Array.from({ length: count }).map((_, index) => (
              <div key={index} className="shimmer-stat-card">
                <div className="shimmer-content">
                  <div className="shimmer-text shimmer-title"></div>
                  <div className="shimmer-text shimmer-value"></div>
                </div>
                <div className="shimmer-icon"></div>
                <div className="shimmer-arrow"></div>
              </div>
            ))}
          </div>
        );
      
      case 'card':
        return (
          <div className="shimmer-card" style={{ height, width }}>
            <div className="shimmer-header"></div>
            <div className="shimmer-content">
              <div className="shimmer-text"></div>
              <div className="shimmer-text"></div>
              <div className="shimmer-text"></div>
            </div>
          </div>
        );
      
      case 'text':
        return (
          <div className="shimmer-text" style={{ height, width }}></div>
        );
      
      case 'circle':
        return (
          <div className="shimmer-circle" style={{ height, width }}></div>
        );
      
      default:
        return (
          <div className="shimmer-card" style={{ height, width }}>
            <div className="shimmer-content">
              <div className="shimmer-text"></div>
              <div className="shimmer-text"></div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="shimmer-loader">
      {renderShimmer()}
    </div>
  );
};

export default ShimmerLoader; 